import type { IComponentController, IScope } from "angular";
import "angular-translate";
import { countBy as lodashCountBy, range as lodashRange } from "lodash";
import { finalize } from "rxjs/operators";

import type { IConfigurationGroup, IResponseWithLoading, ISite } from "App/Modules/Models";
import { DayType } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IDefaultNamingService } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services";

export default class ConfigurationGroupsComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "$translate", "mmSitesRepository", "irDefaultNamingService"];

    public caption: string;

    public dayTypes: string[];

    public site: ISite;

    public subCaption: string;

    public configurations: IResponseWithLoading<IConfigurationGroup[]>;

    constructor(
        private readonly $scope: IScope,
        private readonly $translate: angular.translate.ITranslateService,
        private readonly sitesRepository: ISitesRepository,
        private readonly defaultNamingService: IDefaultNamingService,
    ) {}

    public $onInit() {
        this.caption = "Entities.ConfigurationGroup.ConfigurationGroup";

        this.configurations = {
            isLoading: true,
        };

        this.dayTypes = lodashRange(1, 8).map((v) => DayType[v]);

        extendWithLoadingAndFail(this.sitesRepository.getConfigurationGroups(this.site.id))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (result) => {
                    this.configurations = result;
                    if (!this.configurations.data) {
                        return;
                    }

                    this.configurations.data.forEach((cg) => this.defaultNamingService.nameConfigurationGroup(cg));

                    this.subCaption = "";

                    this.$translate(
                        "Entities.ConfigurationGroup.NumConfigurationGroupsFormat",
                        {
                            numConfigurationGroups: this.configurations.data.length,
                        },
                        "messageformat",
                    ).then((translation) => {
                        this.caption = translation;

                        // translate each type and add the result + count to the subcaption
                        const subCaptionTypes: string[] = [];
                        const typesWithCount = lodashCountBy(this.configurations.data.map((a) => a.typeName));
                        // todo: Rewrite below. Lint error commented out for now.
                        // eslint-disable-next-line no-restricted-syntax
                        for (const type in typesWithCount) {
                            if (typesWithCount.hasOwnProperty(type)) {
                                this.$translate(`Enums.ConfigurationGroupType.${type}`).then((translatedType) => {
                                    const count = typesWithCount[type];
                                    subCaptionTypes.push(`${count} ${translatedType}`);
                                    if (subCaptionTypes.length === Object.keys(typesWithCount).length) {
                                        this.subCaption = subCaptionTypes.join(", ");
                                    }
                                });
                            }
                        }
                    });
                },
                (result) => {
                    this.configurations = result;
                },
            );
    }
}
